// actions.ts

import {
  SET_PERFORMANCE_DATA,
  ADD_PERFORMANCE_DATA,
  UPDATE_PERFORMANCE_DATA,
  SET_ADD_DIALOG_OPEN,
  SET_EDIT_DIALOG_OPEN,
  SET_EDIT_DATA,
  PerformanceActionTypes,
} from "../types/performanceTypes";
import { PerformanceData } from "../types/performanceTypes";

export const setPerformanceData = (
  data: PerformanceData[]
): PerformanceActionTypes => ({
  type: SET_PERFORMANCE_DATA,
  payload: data,
});

export const addPerformanceData = (
  data: PerformanceData
): PerformanceActionTypes => ({
  type: ADD_PERFORMANCE_DATA,
  payload: data,
});

export const updatePerformanceData = (
  index: number,
  data: PerformanceData
): PerformanceActionTypes => ({
  type: UPDATE_PERFORMANCE_DATA,
  payload: { index, data },
});

export const setAddDialogOpen = (isOpen: boolean): PerformanceActionTypes => ({
  type: SET_ADD_DIALOG_OPEN,
  payload: isOpen,
});

export const setEditDialogOpen = (isOpen: boolean): PerformanceActionTypes => ({
  type: SET_EDIT_DIALOG_OPEN,
  payload: isOpen,
});

export const setEditData = (
  data: PerformanceData | null
): PerformanceActionTypes => ({
  type: SET_EDIT_DATA,
  payload: data,
});
